import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, Col, Row} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {IRootState} from 'app/shared/reducers';
import {getEntity} from './incident-report.reducer';

export interface IIncidentReportDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {
}

export const IncidentReportDetail = (props: IIncidentReportDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const {incidentReportEntity} = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          IncidentReport [<b>{incidentReportEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="description">Description</span>
          </dt>
          <dd>{incidentReportEntity.description}</dd>
        </dl>
        <dl className="jh-entity-details">
          <dt>
            <span id="description">Incident Report (English)</span>
          </dt>
          <dd>{incidentReportEntity.enIncident}</dd>
        </dl>

        <dl className="jh-entity-details">
          <dt>
            <span id="description">Incident Report (Local Language)</span>
          </dt>
          <dd>{incidentReportEntity.stIncident}</dd>
        </dl>
        <dl className="jh-entity-details">
          <dt>
            <span id="displayOrder">Display Order</span>
          </dt>
          <dd>{incidentReportEntity.displayOrder}</dd>
        </dl>
        <Button tag={Link} to="/incident-report" replace color="info">
          <FontAwesomeIcon icon="arrow-left"/> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/incident-report/${incidentReportEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt"/> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({incidentReport}: IRootState) => ({
  incidentReportEntity: incidentReport.entity,
});

const mapDispatchToProps = {getEntity};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(IncidentReportDetail);
